import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import InboxRuleFolderType from './InboxRuleFolderType';

export const MAX_MESSAGE_SIZE = 2 /*KB*/ * 1024 /*MB*/ * 1024 /*GB*/ - 1;
export const KB_TO_B = 1024;

type ClauseValueType =
    | InboxRuleFolderType /* moveTo, copyTo */
    | RecipientWellWithFindControlViewState /* from, to */
    | string /* name, before (ISO), after (ISO) */
    | boolean /* pin, attachment */
    | string[] /* subjectContains, category */
    | number; /* atLeast, atMost */

export default ClauseValueType;
